/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Site} from "../../model/Site";
import {SitesService} from "../../services/sites.service";
import {SiteBaseMileage} from "../../model/SiteBaseMileage";
import {SiteBaseMileageService} from "../../services/site-base-mileage.service";
import {NgxSpinnerService} from 'ngx-spinner';
import {BaseMessageComponent} from '../../common/base-message.component';
declare var $:any;

@Component({
    selector: 'app-site-detail',
    templateUrl: './site-detail.component.html',
    styleUrls: ['./site-detail.component.less'],
    standalone: false
})
export class SiteDetailComponent extends BaseMessageComponent implements OnInit {
  public siteId = +this.route.snapshot?.paramMap.get('id');

  @ViewChild('mainBody') siteDetailForm: any;
  site: Site;
  sitesMileage: SiteBaseMileage[] = [];
  indexWithChanges: number[] = [];

  constructor(
    private route: ActivatedRoute,
    private siteService: SitesService,
    private siteMilageService: SiteBaseMileageService,
    private spinnerService: NgxSpinnerService,
    cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.getSite();
  }

  getSite(): void {
    if (this.siteId != undefined && this.siteId != 0) {
      this.spinnerService.show();
      this.siteService.getSite(this.siteId).subscribe(site => {
          this.site = site;
          this.siteId = site.siteId;
          this.getSiteMileage();
          this.cdr.detectChanges();
        }, error => {
          alert("Error" + error.toString());
        }, () =>{
          this.spinnerService.hide();
      });
    }
  }

  getSiteMileage(): void {
    //todo
    this.spinnerService.show();
    this.siteService.getSiteMileageBySiteId(this.siteId).subscribe(siteMilage => {
      this.sitesMileage = siteMilage;
      this.cdr.detectChanges();
    }, err =>{
      if(err.error.errorCode !== "404 Not Found") {
        alert("Error" + err.error.errorcode);
      }
    }, () =>{
      this.spinnerService.hide();
    });
  }

  AddSiteMileage(): void {
    let siteMileage = new SiteBaseMileage();
    siteMileage.siteId = this.siteId;
    siteMileage.siteName = this.site.siteName;
    siteMileage.siteCode = this.site.siteCode;
    this.sitesMileage.push(siteMileage);
  }

  deleteSiteBaseMileage(id): void {
    this.spinnerService.show();
    var result = this.siteMilageService.deleteSiteMileageByid(id).subscribe(value => {
    }, err =>{
      if(err.error.errorCode !== "404 Not Found") {
        alert("Error" + err.error.errorcode);
      }
    }, () =>{
      setTimeout(() => {
        this.spinnerService.hide();
        this.ResetSiteInfo();
      }, 3000);
    });
  }

  ResetSiteInfo(): void {
    this.getSiteMileage();
  }

  updateSitesIndexes(index) {
    if(this.indexWithChanges.indexOf(index)===-1){
      this.indexWithChanges.push(index);
    }
    console.log(this.indexWithChanges);
  }

  private _markFormPristine(form): void {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsPristine();
    });
    $.each($('gm-datepicker span'),function (index,value) {
      $(this).hasClass('ng-touched');
      $(this).removeClass('ng-touched').addClass("ng-untouch");
    });
  }

  saveChanges() {
    this.returnMessage = 'Saving changes';
    this.spinnerService.show();
    setTimeout(() => {
      this.returnMessage = '';
    }, 1000);

    if (this.indexWithChanges.length > 0) {
      for (var i = 0; i < this.indexWithChanges.length; i++) {
        var idx = this.indexWithChanges[i];
        if(this.sitesMileage[idx].siteBaseMileageId != null) {
          this.siteMilageService.updateSiteBaseMileage(this.sitesMileage[idx]).subscribe(value => {
              console.log(this.sitesMileage[idx] + " saved.")
            }, (error) => {
              //failed
              console.error(error);
              this.returnMessage = 'Adding Site Based Mileage return error: ' + error;
              setTimeout(() => {
                this.returnMessage = '';
              }, 3000);
            },
            () => {
              this.spinnerService.hide();
              this.returnMessage = 'Finished adding Site Base Mileage';
              setTimeout(() => {
                this.returnMessage = '';
              }, 3000);
            });
        }
        else {
          this.siteMilageService.saveSiteBaseMileage(this.sitesMileage[idx]).subscribe(value => {
              console.log(this.sitesMileage[idx] + " saved.")
            }, (error) => {
              //failed
              console.error(error);
              this.returnMessage = 'Updating Site Based Mileage return error: ' + error;
              setTimeout(() => {
                this.returnMessage = '';
              }, 3000);
            },
            () => {
              this.returnMessage = 'Finished updating Site Base Mileage';
              setTimeout(() => {
                this.returnMessage = '';
              }, 3000);
            });
        }
        setTimeout(() => {
          this.ResetSiteInfo();
        }, 4000);
      }
    } else {
      this.returnMessage = 'Nothing to add or update';
      setTimeout(() => {
        this.spinnerService.hide();
        this.returnMessage = '';
      }, 3000);
    }
  }
}
